<div class="d-flex justify-content-between align-items-center position-relative" *transloco="let translate">
    <h4 mat-dialog-title class="mat-dialog-title" [textContent]="translate('Search')"></h4>
    <span class="material-icons top-0 right-0 position-absolute cursor-pointer" mat-dialog-close>close</span>
    <ng-container *ngIf="loadingBulkReports">
        <div class="loadingContainer">
            <app-dots-loader [showLoading]="true"></app-dots-loader>
        </div>
    </ng-container>
</div>
<div class="mainSearchFilters" *transloco="let translate">
    <div class="filterSelection py-2">
        <material-radio-group
            ariaLabelledby="filter-selection"
            [radioOptions]="radioOptions"
            [selectedValue]="selectedOutlookFilter"
            (selectionChanged)="selectedOutlookFilter = $event"
            [radioGroupClassList]="['d-flex', 'align-items-center', 'mx-3']"
            [radioButtonClassList]="['searchType']"></material-radio-group>
    </div>
    <div class="ps position-relative selectedFilterContainer h-[50vh]" [perfectScrollbar]>
        <div class="defaultFilterContainer d-flex align-items-center" *ngIf="selectedOutlookFilter === 'searchFilters'">
            <label [textContent]="translate('Search Filters')"></label>
            <mat-form-field class="w-100 col-9" id="searchField" appRemoveAriaOwns>
                <mat-label>
                    <span [textContent]="searchFilters?.length > 0 ? translate('Select Filter') : translate('No Search Filters')"></span>
                </mat-label>
                <mat-select [(ngModel)]="selectedSearchFilter">
                    <mat-option><span [textContent]="translate('Select Filter')"></span></mat-option>
                    <mat-form-field class="searchEntities searchInputField searhFilters px-4">
                        <input
                            matInput
                            [placeholder]="translate('Search Filter')"
                            type="text"
                            [(ngModel)]="selectAssetsName"
                            (click)="$event.stopPropagation()" />
                        <material-button
                            buttonType="icon"
                            [size]="'small'"
                            matSuffix
                            (buttonClicked)="selectAssetsName = ''"
                            [prefixIcon]="selectAssetsName ? 'close' : 'search'"
                            [classList]="['searchEntitiesIcons']"
                            *ngIf="!selectAssetsName"></material-button>
                    </mat-form-field>
                    <ng-container
                        *ngFor="
                            let option of searchFilters
                                | FilterPipe : 'filterName' : selectAssetsName : undefined : undefined : undefined : 'default-filters'
                        ">
                        <ng-container *ngIf="option?.criteria; else isDefaultFilters">
                            <ng-template
                                [ngTemplateOutlet]="searchFilterOptions"
                                [ngTemplateOutletContext]="{ option: option }"></ng-template>
                        </ng-container>
                        <ng-template #isDefaultFilters>
                            <ng-template
                                [ngTemplateOutlet]="searchFilterOptions"
                                [ngTemplateOutletContext]="{ option: option['default-filters'] }"></ng-template>
                        </ng-template>
                    </ng-container>
                    <ng-template #searchFilterOptions let-option="option">
                        <ng-container *ngIf="option.criteria; else isDefaultFilter">
                            <div class="searchFilterOption searchFilter">
                                <mat-option class="selectSearchFilterOpt" [title]="option.filterName" [value]="option">
                                    <span [textContent]="option.filterName"></span>
                                </mat-option>
                                <ng-template
                                    [ngTemplateOutlet]="filterActions"
                                    [ngTemplateOutletContext]="{ option: option }"></ng-template>
                            </div>
                        </ng-container>
                        <ng-template #isDefaultFilter>
                            <mat-divider></mat-divider>
                            <ng-container *ngFor="let defaultFilter of option | FilterPipe : undefined : selectAssetsName; let i = index">
                                <div class="searchFilterOption">
                                    <span
                                        class="material-icons mr-2 position-absolute !text-[16px] text-[#00a651] top-[14px] left-[3px] z-[1] noDefaultColor !px-1"
                                        [title]="translate('Default Filter')"
                                        stop-propagation>
                                        dns
                                    </span>
                                    <mat-option [value]="defaultFilter" class="position-relative" [title]="defaultFilter" stop-propagation>
                                        <span class="ml-2">
                                            <span [textContent]="defaultFilter"></span>
                                        </span>
                                    </mat-option>
                                    <ng-template
                                        [ngTemplateOutlet]="filterActions"
                                        [ngTemplateOutletContext]="{ option: defaultFilter }"></ng-template>
                                </div>
                            </ng-container>
                        </ng-template>
                    </ng-template>
                    <ng-template #filterActions let-option="option">
                        <span class="d-flex align-items-center justify-content-between searchFilterActions" stop-propagation>
                            <span class="d-flex align-items-center" stop-propagation>
                                <span
                                    class="material-icons editSaveFilter cursor-pointer"
                                    (click)="editSaveFilter(option)"
                                    [title]="translate('Edit filter')"
                                    stop-propagation>
                                    edit
                                </span>
                                <span
                                    class="material-icons editSaveFilter mx-1 cursor-pointer"
                                    (click)="downloadReportWithSavedFilter(option)"
                                    [title]="translate('Download Filter Report')"
                                    stop-propagation>
                                    cloud_download
                                </span>
                                <span
                                    class="material-icons deleteSaveFilter cursor-pointer"
                                    [hidden]="option && !option.criteria"
                                    stop-propagation
                                    (click)="deleteSaveFilter(option)"
                                    [title]="translate('Delete filter')">
                                    delete_forever
                                </span>
                            </span>
                        </span>
                    </ng-template>
                    <ng-container *ngIf="searchFilters?.length > 0 && (searchFilters | multiFilter : selectAssetsName).length === 0">
                        <div class="noRecordsContainer">
                            <div class="noSearchRecords">
                                <span>No results found</span>
                            </div>
                        </div>
                    </ng-container>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="ewayBillStatusContainer d-flex align-items-center" *ngIf="selectedOutlookFilter === 'ewaybillByStatus'">
            <label [textContent]="translate('E-Way Bill Status')"></label>
            <mat-form-field appRemoveAriaOwns>
                <mat-label>
                    <span [textContent]="savedSearchOptions?.length > 0 ? translate('Select Status') : translate('No Status')"></span>
                </mat-label>
                <mat-select [(ngModel)]="selectedSearchOption">
                    <mat-option><span [textContent]="translate('Select Status')"></span></mat-option>
                    <mat-form-field class="searchEntities searchInputField searhFilters">
                        <input
                            matInput
                            [placeholder]="translate('Search Filter')"
                            type="text"
                            [(ngModel)]="selectedSearchOption"
                            stop-propagation />
                        <material-button
                            matSuffix
                            [buttonType]="'icon'"
                            [prefixIcon]="selectedSearchOption ? 'close' : 'search'"
                            [prefixIconType]="'material'"
                            (buttonClicked)="selectedSearchOption = ''"
                            aria-label="clear"></material-button>
                    </mat-form-field>
                    <mat-option *ngFor="let option of savedSearchOptions | multiFilter : selectedSearchOption" [value]="option.filterName">
                        <span [textContent]="option.filterName"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <!-- bulk processing -->
        <div class="processStatusContainer" *ngIf="selectedOutlookFilter === 'processStatus'">
            <div class="d-flex align-items-center">
                <label class="mr-3" [textContent]="translate('Process Filter')"></label>
                <mat-form-field class="col-6" appRemoveAriaOwns>
                    <mat-label>
                        <span [textContent]="processStatuses?.length > 0 ? translate('Select Status') : translate('No Status')"></span>
                    </mat-label>
                    <mat-select [(ngModel)]="selectedProcessFilter" (openedChange)="getProcessStatuses($event)">
                        <mat-option><span [textContent]="translate('Select Status')"></span></mat-option>
                        <mat-form-field class="searchInputField !px-4 !min-h-0">
                            <input
                                matInput
                                [placeholder]="translate('Search Filter')"
                                type="text"
                                [(ngModel)]="inputProcessFilter"
                                stop-propagation />
                            <material-button
                                matSuffix
                                [buttonType]="'icon'"
                                [prefixIcon]="inputProcessFilter ? 'close' : 'search'"
                                [prefixIconType]="'material'"
                                (buttonClicked)="inputProcessFilter = ''"
                                aria-label="clear"></material-button>
                        </mat-form-field>
                        <ng-container *ngIf="processStatuses === undefined; else optionsTemplate">
                            <mat-progress-bar mode="query"></mat-progress-bar>
                        </ng-container>
                        <ng-template #optionsTemplate>
                            <ng-container *ngIf="processStatuses?.length > 0; else emptyMessage">
                                <mat-option *ngFor="let process of processSearchFilter()" [value]="process">
                                    <span [textContent]="process | titlecase"></span>
                                </mat-option>
                            </ng-container>
                            <ng-template #emptyMessage>
                                <button mat-menu-item disabled>No options available</button>
                            </ng-template>
                        </ng-template>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="customSearchContainer" *ngIf="selectedOutlookFilter === 'customSearch'">
            <mat-tab-group (selectedTabChange)="selectedTabChange($event)" class="w-100" [selectedIndex]="selectedTab">
                <mat-tab [label]="translate('Rules')">
                    <app-search-builder [search]="searchBuilder" [searchType]="'SEARCH'"></app-search-builder>
                </mat-tab>
                <mat-tab [label]="translate('Relations')">
                    <app-search-builder
                        [search]="searchBuilder"
                        [showQueryBuilderDirectly]="true"
                        searchType="RELATION"
                        [relationConfigExists]="true"></app-search-builder>
                </mat-tab>
                <mat-tab [label]="translate('Download Report')">
                    <ng-container *ngIf="searchBuilder.criteriaUpdated; else showCriteriaMessage">
                        <perfect-scrollbar class="h-[38vh]">
                            <div class="processDownloadReport downloadReportDropdownContainer mat-card w-100 !shadow-none">
                                <div class="transformationsContainer">
                                    <div class="col-9">
                                        <span class="bulkReportCheckBoxCls">
                                            <material-checkbox [(model)]="checkMultiple" [name]="'checkForMultiple'"></material-checkbox>
                                        </span>
                                        <span class="checkBoxSpanCls" [textContent]="translate('Is bulk report?')"></span>
                                        <span class="bulkReportSearchSpan">
                                            <span
                                                [title]="
                                                    translate(
                                                        'Processes for which reports have been generated will be downloaded using this option.'
                                                    )
                                                "
                                                class="material-icons-outlined bulkinfoIcon">
                                                info
                                            </span>
                                        </span>
                                    </div>
                                    <div class="col-9 completeInstanceReportContainer">
                                        <span class="bulkReportCheckBoxCls">
                                            <material-checkbox
                                                [(model)]="isCompleteInstanceReport"
                                                [name]="'checkForCompleteInstanceReport'"
                                                (modelChange)="checkCompleteInstanceReport = $event"></material-checkbox>
                                        </span>
                                        <span
                                            class="checkBoxSpanCls"
                                            [textContent]="translate('Is generate complete process report?')"></span>
                                    </div>
                                    <ng-container *ngIf="checkMultiple">
                                        <div class="row noMargin !mt-[25px]">
                                            <div class="col-6">
                                                <material-selectgroup
                                                    [required]="false"
                                                    [options]="reportMetadata"
                                                    [placeholder]="translate('Select Transformations')"
                                                    [model]="$any(bulkTransformationsList)"
                                                    [optionDisplayNameProperty]="'displayName'"
                                                    [optionValueProperty]="'chainName'"
                                                    (modelChange)="bulkTransformationsList = $event"
                                                    [groupDisplayNameProperty]="'orgName'"
                                                    [groupValueProperty]="'transformations'"
                                                    [title]="$any(bulkTransformationsList)"
                                                    [isMultple]="true"
                                                    [hideSelectIfValueExists]="true"></material-selectgroup>
                                            </div>
                                            <div class="col-4 bulkDownloadBtn">
                                                <material-button
                                                    [classList]="['!w-auto']"
                                                    [text]="'Initiate'"
                                                    [color]="'primary'"
                                                    (buttonClicked)="createDownloadBulkRequest()"
                                                    [disabled]="
                                                        !bulkTransformationsList || !bulkTransformationsList?.length
                                                    "></material-button>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="!checkMultiple">
                                        <div class="row noMargin !mt-[25px]">
                                            <div class="col-6">
                                                <mat-form-field appRemoveAriaOwns>
                                                    <mat-select
                                                        [placeholder]="translate('Select Transformation')"
                                                        [(value)]="selectedReportTransformation"
                                                        name="transformation"
                                                        disableOptionCentering>
                                                        <mat-optgroup
                                                            *ngFor="let group of downloadReportTransformations"
                                                            [label]="group.orgName">
                                                            <mat-option
                                                                *ngFor="let transformation of group.values"
                                                                [value]="transformation"
                                                                (onSelectionChange)="downloadErrorRepositoryId = group.orgId">
                                                                <span
                                                                    [textContent]="
                                                                        transformation.displayName || transformation.name
                                                                    "></span>
                                                            </mat-option>
                                                        </mat-optgroup>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-4 bulkDownloadBtn">
                                                <material-button
                                                    [classList]="['!w-auto']"
                                                    [text]="translate('Initiate')"
                                                    [color]="'primary'"
                                                    (buttonClicked)="initiateDownloadReport()"
                                                    [disabled]="!selectedReportTransformation"></material-button>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </perfect-scrollbar>
                    </ng-container>
                    <ng-template #showCriteriaMessage>
                        <div class="d-flex align-items-center justify-content-center w-full h-[35vh]">
                            <span class="px-2" [textContent]="translate('Create Criteria From Rules Tab')"></span>
                            <a (click)="selectedTabChange({ index: 0 })" [textContent]="translate('Click Here')"></a>
                        </div>
                    </ng-template>
                </mat-tab>
                <mat-tab [label]="translate('Save Filter')">
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="d-flex align-items-center justify-content-center mat-card w-full h-[25vh]">
                            <mat-form-field class="col-6 left-[40px]">
                                <input
                                    type="text"
                                    matInput
                                    [placeholder]="translate('Enter Filter Name')"
                                    [(ngModel)]="saveFilterName"
                                    name="Filter" />
                                <mat-icon matSuffix>mode_edit</mat-icon>
                            </mat-form-field>
                            <material-button
                                class="col-4 left-[40px]"
                                [classList]="['!w-auto']"
                                [color]="'primary'"
                                [text]="translate('Save and Search')"
                                (buttonClicked)="saveAndSearchWithFilter()"
                                [disabled]="!saveFilterName"></material-button>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
        <!-- Filter by time -->
        <ng-container *ngIf="selectedOutlookFilter === 'filterByTime'">
            <app-time-filters [selectedOutlookFilter]="{ name: selectedOutlookFilter }" [timeFilter]="timeFilter"></app-time-filters>
        </ng-container>
    </div>
    <div class="align-items-center buttonFields d-flex">
        <ng-container *ngIf="selectedOutlookFilter === 'searchFilters'">
            <material-button
                class="noOutline submitColor ml-auto"
                [color]="'primary'"
                [text]="translate('Apply Filter')"
                [disabled]="!selectedSearchFilter"
                (buttonClicked)="applyDefaultSearchFilter()"></material-button>
        </ng-container>
        <ng-container *ngIf="selectedOutlookFilter === 'processStatus'">
            <material-button
                class="noOutline submitColor ml-auto"
                [color]="'primary'"
                [text]="translate('Apply Filter')"
                [disabled]="!selectedProcessFilter"
                (buttonClicked)="applySelectedProcessFilter()"></material-button>
        </ng-container>
        <ng-container *ngIf="selectedOutlookFilter === 'customSearch'">
            <div class="d-flex align-items-center justify-content-start">
                <material-button
                    [disabled]="!searchBuilder.criteriaUpdated"
                    class="noOutline submitColor mx-2"
                    [color]="'primary'"
                    [text]="translate('Search')"
                    (buttonClicked)="startNewSearch()"
                    [hidden]="selectedTab === 3"></material-button>
                <material-button
                    [color]="'primary'"
                    [disabled]="!searchBuilder.criteriaUpdated"
                    class="noOutline submitColor mx-2"
                    [text]="translate('Download')"
                    (buttonClicked)="selectedTab = 2"
                    [hidden]="selectedTab === 2 || selectedTab === 3"></material-button>
                <material-button
                    [color]="'primary'"
                    [disabled]="!searchBuilder.criteriaUpdated"
                    class="noOutline submitColor mx-2"
                    [text]="searchFilter?.id ? translate('Update Filter') : translate('Save Filter')"
                    (buttonClicked)="selectedTab = 3"
                    [hidden]="selectedTab === 3"></material-button>
                <material-button
                    [color]="'primary'"
                    class="noOutline submitColor mx-2"
                    [text]="!searchBuilder.criteriaUpdated ? translate('Add Criteria') : translate('Update Criteria')"
                    (buttonClicked)="searchBuilder.buildCriterias()"
                    [hidden]="selectedTab === 3 || selectedTab === 2"></material-button>
            </div>
            <material-button
                class="mat-elevation-z1 ml-auto"
                [text]="translate('Reset Criteria')"
                [hidden]="selectedTab === 3"
                [disabled]="!searchBuilder.criteriaUpdated"
                (buttonClicked)="resetFilterCriteria()"></material-button>
        </ng-container>
        <ng-container *ngIf="selectedOutlookFilter === 'filterByTime'">
            <material-button
                class="noOutline submitColor ml-auto"
                [color]="'primary'"
                [text]="translate('Apply')"
                [disabled]="!timeFilter.endDate || !timeFilter.startDate"
                (buttonClicked)="searchByTimeRange()"></material-button>
        </ng-container>
        <ng-container *ngIf="selectedOutlookFilter">
            <material-button
                class="mat-elevation-z1 !ml-[10px]"
                [text]="translate('Clear Filters')"
                [hidden]="selectedTab === 3"
                (buttonClicked)="clearAllFilters()"></material-button>
        </ng-container>
    </div>
</div>
